export enum ProfileIconType {
  LETTER = 'letter',
  ICON = 'icon',
  IMAGE = 'image',
}

export enum ParentalControlStep {
  SET_PARENTAL_ON = 'set-parental-on',
  SET_PARENTAL_OFF = 'set-parental-off',
  CHANGE_CONTENT = 'change-content',
  CHANGE_PIN = 'change-pin',
}

export enum KidsTagVariant {
  DEFAULT = 'default',
  MENU = 'menu',
}
